import styled from "styled-components";
import {CrossBrandItemIconDefaultBox} from "./cross-brand-item-icon.default.box";

export const CrossBrandItemIconMrGreenBox = styled(CrossBrandItemIconDefaultBox)`
  margin: 0 1rem 0 0;

  height: 24px;
  &.sport-brand {
    background-position: -158px -678px;
  }

  &.casino-brand {
    background-position: -267px -678px;
  }
`;
